import React from 'react'

import '../../assets/style/ui/circle.css'

const CircleFinish = ({ gradient, size }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: gradient,
      }}
    ></div>
  )
}

export default CircleFinish
